module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/93241021a13aa20da27f50e661016310.png";